import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import {
  BorderedWrapper,
  BorderedItem
} from "editor/components/CollapseWrapper";
import Switch from "./SwitchComponent/Switch";
import { PropListItem, PropLabel } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
`;

const CustomPropLabel = styled(PropLabel)`
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2px;
`;

const CustomBorderedWrapper = styled(BorderedWrapper)`
  width: 100%;
`;

const CustomBorderedItem = styled(BorderedItem)`
  display: flex;
  align-items: center;
  line-height: 40px;
`;

class Visibility extends Component {
  constructor(props) {
    super(props);
    this.options = [
      {
        label: "phone",
        className: "hidden-xs"
      },
      {
        label: "tablet",
        className: "hidden-sm"
      },
      {
        label: "desktop",
        className: "hidden-md"
      }
    ];
  }

  handleChange = change => {
    const { currentValue, updaterFn, name } = this.props;
    const classList = this.options
      .map(option => {
        const evaluator =
          option.label === change.name
            ? change.value
            : currentValue[option.label];
        return evaluator ? null : option.className;
      })
      .filter(item => item !== null)
      .join(" ");
    const newValues = {
      ...currentValue,
      [change.name]: change.value
    };
    updaterFn([
      { prop: name, value: newValues },
      { prop: "visibilityClasses", value: classList }
    ]);
  };

  getItems = () => {
    const { currentValue } = this.props;
    return this.options.map(opt => ({
      name: opt.label,
      label: I18n.t(`editPanel.visibility.${opt.label}`),
      className: opt.className,
      value: currentValue[opt.label]
    }));
  };

  render() {
    const { locale, label, tooltip } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;
    const items = this.getItems();

    return (
      <CustomPropListItem>
        <CustomPropLabel>
          <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
        </CustomPropLabel>
        <CustomBorderedWrapper>
          {items.map(item => {
            return (
              <CustomBorderedItem key={`visibile-${item.label}`}>
                <span>{item.label}</span>
                <Switch
                  value={item.value}
                  onClick={() => {
                    const obj = {
                      name: item.name,
                      value: !item.value
                    };
                    this.handleChange(obj);
                  }}
                />
              </CustomBorderedItem>
            );
          })}
        </CustomBorderedWrapper>
      </CustomPropListItem>
    );
  }
}

export default Visibility;
